import { createSlice } from "@reduxjs/toolkit";

export const chatSocketInstance = createSlice({
  name: "chat_socket_instance",
  initialState: {
    value: {
      status: false,
      socketInstance: null,
    },
  },
  reducers: {
    updateSocketInstance: (state, action) => {
      state.value.status = true;
      state.value.socketInstance = action.payload;
    },
  },
});

export const { updateSocketInstance } = chatSocketInstance.actions;

export default chatSocketInstance.reducer;
